import { useUser } from '@fs/zion-user'
import { useDSCState } from '../../state/DSCStore'
import { getUserEmail } from '../helpers/utility'

/**
 * Custom hook to check if the current user has a valid email address.
 *
 * Checks for email in the following order:
 * 1. DSC state nonstandardUser email
 * 2. User email
 * 3. User loggedInUserContact email
 *
 * @returns {boolean} True if a valid email address exists, false otherwise
 */
export const useHasEmail = () => {
  const dscState = useDSCState()
  const user = useUser()
  return !!getUserEmail(dscState, user)
}
